export const clearFieldsOnChange = (fields = [], setFieldValue) => fields.forEach(f => setFieldValue(f, ''));

const fields_utils = {
    notes: {
        notes: {
            placeholder: "Notes...",
            value: "",
            type: "textarea",
        },
    },
    title: {
        title: {
            label: "Title",
            value: null,
            type: "select",
            required: true,
            orderOptions: false,
            options: [
                {key: "mr", value: "Mr"},
                {key: "ms", value: "Ms"},
                {key: "mrs", value: "Mrs"},
                {key: "miss", value: "Miss"},
            ],
        },
    },
    marketing: {
        marketing_email: {
            label: "Email",
            value: null,
            type: "bool",
            required: true,
            options: [
                {key: false, value: "no"},
                {key: true, value: "yes"},
            ],
        },
        marketing_phone: {
            label: "Telephone",
            value: null,
            type: "bool",
            required: true,
            options: [
                {key: false, value: "no"},
                {key: true, value: "yes"},
            ],
        },
        marketing_sms: {
            label: "SMS",
            value: null,
            type: "bool",
            required: true,
            options: [
                {key: false, value: "no"},
                {key: true, value: "yes"},
            ],
        },
    },
    energy_usage: {
        has_electricity_usage: {
            label: "Do you know your electricity usage?",
            value: null,
            type: "radio",
            required: true,
            options: [
                {key: false, value: "no"},
                {key: true, value: "yes"},
            ],
        },
        electricity_spend_type: {
            label: "Is this in spend(£) or kilowatts(kWh)?",
            value: null,
            type: "radio",
            required: true,
            options: [
                {key: "spend(£)", value: "spend"},
                {key: "kilowatts(kWh)", value: "kilowatts"},
            ],
        },
        electricity_billing_period: {
            label: "What billing period is this based on?",
            value: null,
            type: "radio",
            required: true,
            options: [],
        },
        electricity_usage: {
            label: "How much do you spend?",
            value: "",
            type: "number",
            placeholder: "0",
            required: true,
        },
        has_gas_usage: {
            label: "Do you know your gas usage?",
            value: false,
            type: "radio",
            required: true,
            options: [
                {key: false, value: "no"},
                {key: true, value: "yes"},
            ],
        },
        gas_spend_type: {
            label: "Is this in spend(£) or kilowatts(kWh)?",
            value: null,
            type: "radio",
            required: true,
            options: [],
        },
        gas_billing_period: {
            label: "What billing period is this based on?",
            value: null,
            type: "radio",
            required: true,
            options: [],
        },
        gas_usage: {
            label: "How much do you spend?",
            value: null,
            type: "number",
            placeholder: "0",
            required: true,
        },
    },
    cross_selling: {
        cross_selling_products: {
            value: [],
        },
        cross_selling_time: {
            label: "Contact Time",
            type: "select",
            options: [],
        },
    },
    overnight_location: {
        label: "Where is the motorbike left overnight?",
        type: 'select',
        value: '',
        options: [],
        required: true,
        placeholder: 'car park'
    },
    mileage: {
        label: 'Mileage',
        type: 'number',
        value: 0,
        required: true,
        placeholder: '100'
    },
};
export default fields_utils;
